import { createAction, props } from '@ngrx/store';

export const SetTitle = createAction('[Meta] Set meta title', props<{ title: string }>());
export const SetTags = createAction('[Meta] Set meta tags', props<{ properties: { [property: string]: string } }>());
